<p-dialog
  [(visible)]="showDialog"
  [modal]="true"
  [style]="{ margin: '0 2rem', minWidth: '300px' , maxWidth: '400px' }"
  [draggable]="false"
  [closable]="true"
>
  <ng-template pTemplate="header">
    <div class="flex flex-column gap-2">
      <img src="assets/icons/sp_alert.svg" width="56" height="56" alt="" />
      <span class="t-20-600-primary mt-2">{{ modalData?.title || 'Información' }}</span>
    </div>
  </ng-template>
  <ng-template pTemplate="closeicon">
    <div class="flex" (click)="closeModal()">
      <img
        src="assets/icons/ic_close_circle.svg"
        width="24"
        height="24"
        alt=""
        style="cursor: pointer;"
      />
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <p class="t-14-400-dark">
      <ng-container *ngFor="let part of getMessageParts(modalData?.message || 'Se ha producido una situación que requiere tu atención.', modalData?.isSuccessMessage)">
        @if (!part.isEmail) {
          <span>{{ part.text }}</span>
        }
        @if (part.isEmail) {
          <a
            [href]="'mailto:' + part.email"
            style="color: #007B83; text-decoration: underline;"
            >{{ part.text }}</a
          >
        }
      </ng-container>
    </p>
  </ng-template>
  <ng-template pTemplate="footer" class="pt-5">
    <p-button [label]="modalData?.buttonText || 'Aceptar'" (click)="closeModal()"></p-button>
  </ng-template>
</p-dialog>
